import QaTabContent from '@/components/community/tabs/QaTab.vue';
import { mountCommunityComponentAsApp } from '@/entrypoints/shared/community-mounter';
import { mountProductTab } from '@/entrypoints/shared/tab-mounter';

const mountSelector = '.product-tab-q-and-a-container';
const boundTabSelector = '#tab-qa';

mountProductTab(
  QaTabContent,
  mountSelector,
  boundTabSelector,
  mountCommunityComponentAsApp
);
